import { webConfigHttp } from '@/utils/request'

/** 列表接口路径（与平台文档一致） */
export const WEB_CONFIG_CONTENT_LIST_PATH = '/api/web/content/list'

/** 详情/预览接口路径占位（以平台最终文档为准，对接时替换） */
export const WEB_CONFIG_CONTENT_DETAIL_PATH = '/api/web/content/detail'

/** 当前站点内容资源 key（商品列表等） */
export const DEFAULT_WEB_CONTENT_KEY = 'goods'

const defaultSort = Object.freeze([
  ['weight', 'desc'],
  ['createdAt', 'desc'],
  ['publishTime', 'desc'],
])

/**
 * 内容列表（POST /api/web/content/list）
 * @param {Record<string, unknown>} [payload] 与平台文档一致的 body，未传字段将用默认值补齐
 */
export function fetchGoodsList(payload = {}) {
  const {
    key = DEFAULT_WEB_CONTENT_KEY,
    index = 1,
    size = 10,
    filter = {},
    sort = defaultSort,
    ...rest
  } = payload
  return webConfigHttp.post(WEB_CONFIG_CONTENT_LIST_PATH, {
    key,
    index,
    size,
    filter,
    sort,
    ...rest,
  })
}

/**
 * 解析 content/list 的 axios 响应，取出 rows。
 * 兼容：① 标准 { code, data: { count, rows, options }, msg }；② 仅扁平 { rows, count }（无 code 包裹）。
 * code 支持数值或字符串（如 "200"）。
 *
 * @param {import('axios').AxiosResponse<{ code?: number | string, data?: { rows?: unknown[] }, rows?: unknown[], msg?: string }>} res
 * @returns {{ rows: unknown[] }}
 */
export function parseContentListResponse(res) {
  const d = res && res.data
  if (!d || typeof d !== 'object') {
    return { rows: [] }
  }
  if (d.code != null && Number(d.code) !== 200) {
    throw new Error(d.msg || 'list request failed')
  }
  const body =
    d.data != null && typeof d.data === 'object' && !Array.isArray(d.data)
      ? d.data
      : d
  const rows = Array.isArray(body.rows) ? body.rows : []
  return { rows }
}

/**
 * 预览/详情：将 URL 中的 previewToken 传入详情接口（路径与 body 以平台最终文档为准）。
 * @param {string} previewToken
 * @param {Record<string, unknown>} [extra] 额外 body 字段
 */
export function fetchWebContentPreviewDetail(previewToken, extra = {}) {
  return webConfigHttp.post(WEB_CONFIG_CONTENT_DETAIL_PATH, {
    key: DEFAULT_WEB_CONTENT_KEY,
    previewToken,
    ...extra,
  })
}
